import React from "react";
import "./Skills.scss";
import { images } from "../../constants";
import { motion } from "framer-motion";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Skills = () => {
  return (
    <div className="skills__container" id="skills">
      <div className="skillsandlogo__wrapper">
        <motion.div
          whileInView={{ x: [-100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.5 }}
        >
          <p className="skills__headline">Skills</p>
          <p className="skills__description">
            These are the technologies I've worked with:
          </p>
        </motion.div>

        <motion.div
          variants={scaleVariants}
          whileInView={scaleVariants.whileInView}
          className="logo__container"
        >
          <div>
            <img className="logo" src={images.html} alt="html" />
            <p className="logo__text">HTML</p>
          </div>
          <div>
            <img className="logo" src={images.css} alt="css" />
            <p className="logo__text">CSS</p>
          </div>
          <div>
            <img className="logo" src={images.js} alt="javascript" />
            <p className="logo__text">JavaScript</p>
          </div>
          <div>
            <img className="logo" src={images.react} alt="react" />
            <p className="logo__text">ReactJS</p>
          </div>
          <div>
            <img className="logo" src={images.reactnative} alt="reactnative" />
            <p className="logo__text">React Native</p>
          </div>
          <div>
            <img className="logo" src={images.sass} alt="node" />
            <p className="logo__text">Sass</p>
          </div>
          <div>
            <img className="logo" src={images.tailwind} alt="express" />
            <p className="logo__text">Tailwind CSS</p>
          </div>
          <div>
            <img className="logo" src={images.github1} alt="mongodb" />
            <p className="logo__text">GitHub</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Skills;
